export class StreamProxy {
  constructor(stream, progress = null) {
    this._stream = stream;
    this._queue = [];
    this._done = true;
    this._fetchPromise = null;
    this._maxGetSize = 50000000; //50MB
    this._bytesRead = 0;
    this._progress = progress;
  }

  async start() {
    this._done = false;
    while (!this._done) {
      this._fetchPromise = this._stream.read();
      const {done, value} = await this._fetchPromise;
      this._done = done;
      if (!done) this._queue.push(value);
    }
  }

  //merge and pop queue head into chunk (withUnion==true) or pop first chunk (withUnion==false)
  async getChunk(withUnion = true) {
    if (this._queue.length === 0 && !this._done) await this._fetchPromise;
    if (this._queue.length === 0) return null;

    const unionSize = withUnion ? this._queue.length : 1;
    return this._popChunkUnion(unionSize);
  }

  //merge and pop queue head without last element into chunk and return last element
  async getTwoChunks() {
    while (this._queue.length < 2 && !this._done) {
      await this._fetchPromise;
    }
    if (this._queue.length === 0) return [null, null];
    if (this._queue.length === 1) return [this._queue.shift(), null];

    let firstChunk = this._popChunkUnion(this._queue.length-1);
    let secondChunk = this._queue[0];
    return [firstChunk, secondChunk];
  }

  _popChunkUnion(count) {
    let totalSize = this._queue[0].byteLength;
    let chunksCount = 1;
    for (;chunksCount<this._queue.length && chunksCount<count; chunksCount++) {
      const chunk = this._queue[chunksCount];
      if (totalSize + chunk.byteLength > this._maxGetSize) break;

      totalSize+=chunk.byteLength;
    }

    let union;
    if (chunksCount === 1) {
      union = this._queue.shift();
    } else {
      union = new Uint8Array(totalSize);
      let unionPtr = 0;
      for (let i=0; i<chunksCount; i++) {
        const chunk = this._queue[i];
        union.set(chunk, unionPtr);
        unionPtr+=chunk.byteLength;
      }
      this._queue = this._queue.slice(chunksCount);
    }
    this._bytesRead += totalSize;
    if (this._progress) this._progress.emit(this._progress.LOADING, this._bytesRead / this._stream.byteLength);

    return union;
  }
}
